import { render, staticRenderFns } from "./ActivityCreateUpdate.vue?vue&type=template&id=223ba8ae&scoped=true&"
import script from "./ActivityCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./ActivityCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ActivityCreateUpdate.vue?vue&type=style&index=0&id=223ba8ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223ba8ae",
  null
  
)

export default component.exports